import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboRaza`, method: 'GET', body: null, token: token})
}
